import { ViewIdSchema, ViewSchema } from "@storytell/types";
import z from "zod";

export const ViewIdParamsSchema = z.object({
  id: z.string(),
});

export const CreateViewInputSchema = ViewSchema.pick({
  name: true,
  description: true,
  filters: true,
});

export const UpdateViewInputSchema = ViewSchema.pick({
  id: true,
  name: true,
  description: true,
  filters: true,
});

// Sync endpoint returns a map of view IDs to view objects
export const ViewsSyncSchema = z.object({
  views: z.record(ViewIdSchema, ViewSchema),
});
